import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        
        // Verificar si el token ha expirado
        if (decoded.exp < currentTime) {
          console.log('Token expirado, limpiando localStorage');
          localStorage.removeItem('token');
          setUser(null);
          setLoading(false);
          return;
        }

        // Intentar obtener datos del usuario desde el servidor
        const fetchUserData = async () => {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/${decoded.id}`, {
              headers: {
                'Authorization': `Bearer ${token}`,
              }
            });

            if (response.ok) {
              const userData = await response.json();
              setUser(userData); 
            } else {
              console.log('Error al obtener datos del usuario, limpiando token');
              localStorage.removeItem('token');
              setUser(null);
            }
          } catch (error) {
            console.error('Error al obtener datos del usuario:', error);
            // Si hay error de red, usar los datos del token como fallback
            setUser({
              id_usuario: decoded.id,
              correo: decoded.correo,
              rol: decoded.rol,
              nombre: decoded.nombre,
              apellido_paterno: decoded.apellido_paterno,
              apellido_materno: decoded.apellido_materno,
              foto: decoded.foto
            });
          } finally {
            setLoading(false);
          }
        };

        fetchUserData();
      } catch (error) {
        console.error('Error al decodificar token:', error);
        localStorage.removeItem('token');
        setUser(null);
        setLoading(false);
      }
    } else {
      setUser(null);
      setLoading(false);
    }
  }, []);

  const updateUserProfile = (newUserData) => {
    setUser(newUserData);
  };

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUserProfile, loading }}>
      {children}
    </AuthContext.Provider>
  );
}